import React from "react";
import { numberFormat } from "../../../../../helpers/numberFormat";
import { useSelector, useDispatch } from "react-redux";
import axios from "../../../../../lib/axios";
import { IconTrash } from "@tabler/icons-react";
import errorHandler from "../../../../../helpers/errorHandler";

const FiveSummaryWebIndividu = (props) => {
  const dispatch = useDispatch();
  const dataInputRegistration = useSelector(
    (state) => state.dataInputRegistration
  );
  const scheduleSelected = useSelector((state) => state.scheduleSelected);
  const bpScheduleSelected = useSelector((state) => state.bpScheduleSelected);
  const categoryUser = useSelector((state) => state.categoryUserSelected);
  const np = useSelector((state) => state.nominalPayment);
  const individuParticipants = [];

  const handleChangeFormInput = (key, e) => {
    dispatch({ type: key, value: e.target.value });
  };

  const handleGetSubTotal = () => {
    // alert(categoryUser.value)
    // return false
    if (
      categoryUser.value === "individu" ||
      categoryUser.value === "individual"
    ) {
      let scheduleIds = ""; // eslint-disable-line

      scheduleSelected.forEach((schedule, i) => {
        individuParticipants.push(
          (scheduleIds = {
            id: schedule.scheduleId,
            bpId: null,
            userCategory: "individu",
            isBundling: "false",
            participants: [
              {
                firstName: dataInputRegistration.namaDepanPic,
                lastName: dataInputRegistration.namaBelakangPic,
                email: dataInputRegistration.emailPic,
              },
            ],
          })
        );
      });

      bpScheduleSelected.forEach((schedule, i) => {
        individuParticipants.push(
          (scheduleIds = {
            id: schedule.scheduleId,
            bpId: schedule.bpId,
            userCategory: "individu",
            isBundling: "true",
            participants: [
              {
                firstName: dataInputRegistration.namaDepanPic,
                lastName: dataInputRegistration.namaBelakangPic,
                email: dataInputRegistration.emailPic,
              },
            ],
          })
        );
      });

      const requestBody = {
        SchedulesId: individuParticipants,
        referralCode: dataInputRegistration.refCode,
        useEarlyBird:
          dataInputRegistration.isUsingEarlyBird === true ? "yes" : "no",
      };

      //   console.log(requestBody);
      //   return false;

      axios({
        url: "/users/transactions/nominalPayments",
        method: "POST",
        data: requestBody,
      })
        .then((res) => {
          // console.log(res?.data?.data)
          //   return false;
          dispatch({
            type: "SET_NOMINAL_PAYMENT",
            nominalPayment: res.data.data,
          });
          if (res.data.data.deductionItems[0][0].label === "Early Bird") {
            dispatch({ type: "SET_USING_EARLY_BIRD", value: true });
            dispatch({ type: "SET_EARLY_BIRD", value: true });
            dispatch({ type: "SET_USING_REFERRAL", value: false });
          }

          if (
            res.data.data.deductionItems[0][0].label !== "Early Bird" ||
            res.data.data.deductionItems[0][0].label !== "Bundling Programs"
          ) {
            dispatch({ type: "SET_USING_EARLY_BIRD", value: false });
            dispatch({ type: "SET_EARLY_BIRD", value: false });
            dispatch({ type: "SET_USING_REFERRAL", value: true });
          }
        })
        .catch((err) => {
          if (err !== "") {
            errorHandler({ err: err?.response?.data || err });
            console.log(err);
          }
        });
    }
  };

  const handleUsingEarlyBirdAgain = () => {
    // alert(categoryUser.value)
    // return false
    if (
      categoryUser.value === "individu" ||
      categoryUser.value === "individual"
    ) {
      let scheduleIds = ""; // eslint-disable-line

      scheduleSelected.forEach((schedule, i) => {
        individuParticipants.push(
          (scheduleIds = {
            id: schedule.scheduleId,
            bpId: null,
            userCategory: "individu",
            isBundling: "false",
            participants: [
              {
                firstName: dataInputRegistration.namaDepanPic,
                lastName: dataInputRegistration.namaBelakangPic,
                email: dataInputRegistration.emailPic,
              },
            ],
          })
        );
      });

      bpScheduleSelected.forEach((schedule, i) => {
        individuParticipants.push(
          (scheduleIds = {
            id: schedule.scheduleId,
            bpId: schedule.bpId,
            userCategory: "individu",
            isBundling: "true",
            participants: [
              {
                firstName: dataInputRegistration.namaDepanPic,
                lastName: dataInputRegistration.namaBelakangPic,
                email: dataInputRegistration.emailPic,
              },
            ],
          })
        );
      });

      const requestBody = {
        SchedulesId: individuParticipants,
        referralCode: dataInputRegistration.refCode,
        useEarlyBird: "yes",
      };

      //   console.log(requestBody);
      //   return false;

      axios({
        url: "/users/transactions/nominalPayments",
        method: "POST",
        data: requestBody,
      })
        .then((res) => {
          // console.log(res?.data?.data)
          //   return false;
          dispatch({
            type: "SET_NOMINAL_PAYMENT",
            nominalPayment: res.data.data,
          });
          if (res.data.data.deductionItems[0][0].label === "Early Bird") {
            dispatch({ type: "SET_USING_EARLY_BIRD", value: true });
            dispatch({ type: "SET_EARLY_BIRD", value: true });
            dispatch({ type: "SET_USING_REFERRAL", value: false });
          }

          if (
            res.data.data.deductionItems[0][0].label !== "Early Bird" ||
            res.data.data.deductionItems[0][0].label !== "Bundling Programs"
          ) {
            dispatch({ type: "SET_USING_EARLY_BIRD", value: false });
            dispatch({ type: "SET_EARLY_BIRD", value: false });
            dispatch({ type: "SET_USING_REFERRAL", value: true });
          }
        })
        .catch((err) => {
          if (err !== "") {
            errorHandler({ err: err?.response?.data || err });
            console.log(err);
          }
        });
    }
  };

  const handleRemoveRefCode = () => {
    dispatch({ type: "SET_REF_CODE", value: "" });

    let scheduleIds = ""; // eslint-disable-line
    scheduleSelected.forEach((schedule, i) => {
      individuParticipants.push(
        (scheduleIds = {
          id: schedule.scheduleId,
          isBundling: "false",
          participants: [
            {
              firstName: dataInputRegistration.namaDepanPic,
              lastName: dataInputRegistration.namaBelakangPic,
              email: dataInputRegistration.emailPic,
            },
          ],
        })
      );
    });

    bpScheduleSelected.forEach((schedule, i) => {
      individuParticipants.push(
        (scheduleIds = {
          id: schedule.scheduleId,
          bpId: schedule.bpId,
          userCategory: "individu",
          isBundling: "true",
          participants: [
            {
              firstName: dataInputRegistration.namaDepanPic,
              lastName: dataInputRegistration.namaBelakangPic,
              email: dataInputRegistration.emailPic,
            },
          ],
        })
      );
    });

    const requestBody = {
      SchedulesId: individuParticipants,
      referralCode: "",
      useEarlyBird:
        dataInputRegistration.isUsingEarlyBird === true ? "yes" : "no",
    };
    // console.log(requestBody);
    // return false;
    axios({
      url: "/users/transactions/nominalPayments",
      method: "POST",
      data: requestBody,
    })
      .then((res) => {
        // alert('masuk')
        // console.log(res?.data?.data)
        dispatch({
          type: "SET_NOMINAL_PAYMENT",
          nominalPayment: res.data.data,
        });

        dispatch({ type: "SET_USING_REFERRAL", value: false });
      })
      .catch((err) => {
        if (err !== "") {
          console.log(err?.response?.data);
        }
      });
  };

  const handleNotUsingEarlyBird = () => {
    dispatch({ type: "SET_USING_EARLY_BIRD", value: false });
    let scheduleIds = ""; // eslint-disable-line

    scheduleSelected.forEach((schedule, i) => {
      individuParticipants.push(
        (scheduleIds = {
          id: schedule.scheduleId,
          bpId: null,
          userCategory: "individu",
          isBundling: "false",
          participants: [
            {
              firstName: dataInputRegistration.namaDepanPic,
              lastName: dataInputRegistration.namaBelakangPic,
              email: dataInputRegistration.emailPic,
            },
          ],
        })
      );
    });

    bpScheduleSelected.forEach((schedule, i) => {
      individuParticipants.push(
        (scheduleIds = {
          id: schedule.scheduleId,
          bpId: schedule.bpId,
          userCategory: "individu",
          isBundling: "true",
          participants: [
            {
              firstName: dataInputRegistration.namaDepanPic,
              lastName: dataInputRegistration.namaBelakangPic,
              email: dataInputRegistration.emailPic,
            },
          ],
        })
      );
    });

    const requestBody = {
      SchedulesId: individuParticipants,
      referralCode: dataInputRegistration.refCode,
      useEarlyBird: "no",
    };

    axios({
      url: "/users/transactions/nominalPayments",
      method: "POST",
      data: requestBody,
    })
      .then((res) => {
        // console.log(res?.data?.data)
        // return false
        dispatch({
          type: "SET_NOMINAL_PAYMENT",
          nominalPayment: res.data.data,
        });
      })
      .catch((err) => {
        if (err !== "") {
          errorHandler({ err: err?.response?.data || err });
          console.log(err);
        }
      });
  };

  // console.log(np.nominalPayment.deductionItems[0][0].label);

  return (
    <>
      {np.nominalPayment !== undefined ? (
        <>
          <div
            className="col-lg-12 d-flex justify-content-end"
            style={{ textAlign: "right", marginLeft: "5px", marginTop: "2%" }}
          >
            <table width="60%" style={{ margin: "1%" }}>
              <tr>
                <th
                  style={{
                    fontWeight: "500",
                    fontSize: props.size.width < 500 ? "12px" : "14px",
                  }}
                >
                  Sub Total
                </th>
                <th
                  style={{
                    fontWeight: "600",
                    fontSize: props.size.width < 500 ? "12px" : "15px",
                  }}
                >
                  Rp. {numberFormat(np.nominalPayment.amount)}
                </th>
              </tr>
              <tr>
                <th
                  style={{
                    fontWeight: "500",
                    fontSize: props.size.width < 500 ? "12px" : "14px",
                  }}
                >
                  Potongan Harga
                </th>
                <th
                  style={{
                    fontWeight: "600",
                    fontSize: props.size.width < 500 ? "12px" : "15px",
                    color: "#F1416C",
                  }}
                >
                  {dataInputRegistration.isEarlyBird === true ? (
                    dataInputRegistration.isUsingEarlyBird === true ? (
                      <>
                        <input
                          type="checkbox"
                          className="large-checkbox"
                          checked
                          onClick={handleNotUsingEarlyBird}
                        />
                        &nbsp;
                      </>
                    ) : (
                      <>
                        <input
                          type="checkbox"
                          className="large-checkbox"
                          onClick={handleUsingEarlyBirdAgain}
                        />
                        &nbsp;
                      </>
                    )
                  ) : (
                    ""
                  )}
                  {np.nominalPayment.deductionItems[0][0]?.label} - (Rp.{" "}
                  {numberFormat(np.nominalPayment.deduction)})
                </th>
              </tr>
              <tr>
                <th
                  style={{
                    fontWeight: "500",
                    fontSize: props.size.width < 500 ? "12px" : "14px",
                  }}
                >
                  PPN (12%)
                </th>
                <th
                  style={{
                    fontWeight: "600",
                    fontSize: props.size.width < 500 ? "12px" : "15px",
                  }}
                >
                  Rp. {numberFormat(np.nominalPayment.ppn)}
                </th>
              </tr>

              <tr>
                <th></th>
                <th>
                  _______________________________________________________________
                </th>
              </tr>
              <tr>
                <th
                  style={{
                    fontWeight: "bold",
                    fontSize: props.size.width < 500 ? "12px" : "15px",
                    textAlign: "left",
                  }}
                >
                  Total
                </th>
                <th
                  style={{
                    fontWeight: "bold",
                    fontSize: props.size.width < 500 ? "12px" : "15px",
                    color: "#0C86D9",
                  }}
                >
                  Rp. {numberFormat(np.nominalPayment.grandtotal)}
                </th>
              </tr>
              <tr style={{ textAlign: "left" }}>
                <th colSpan={2}>
                  <p
                    style={{
                      fontWeight: "400",
                      fontSize: props.size.width < 500 ? "12px" : "13px",
                      marginTop: "2%",
                    }}
                  >
                    Gunakan Kode Referral / Kode Voucher untuk dapatkan potongan
                    harga
                  </p>
                </th>
              </tr>
              <tr style={{ textAlign: "right" }}>
                <th colSpan={2}>
                  <div className="input-group">
                    {bpScheduleSelected.length > 0 ||
                      dataInputRegistration.isUsingEarlyBird === true ? (
                      <>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Kode Referral / Kode Voucher (Jika Ada)"
                          aria-describedby="button-addon2"
                          disabled={true}
                        />

                        <button
                          onClick={handleGetSubTotal}
                          className="btn btn-secondary"
                          type="button"
                          id="button-addon2"
                          disabled={
                            dataInputRegistration.refCode.length > 0
                              ? false
                              : true
                          }
                        >
                          TERAPKAN
                        </button>
                      </>
                    ) : (
                      <>
                        <input
                          onChange={(e) =>
                            handleChangeFormInput("SET_REF_CODE", e)
                          }
                          value={dataInputRegistration.refCode}
                          type="text"
                          className="form-control"
                          placeholder="Kode Referral / Kode Voucher (Jika Ada)"
                          aria-describedby="button-addon2"
                        />

                        <button
                          onClick={handleGetSubTotal}
                          className="btn btn-success"
                          type="button"
                          id="button-addon2"
                          disabled={
                            dataInputRegistration.refCode.length > 0
                              ? false
                              : true
                          }
                        >
                          TERAPKAN
                        </button>
                      </>
                    )}

                    {dataInputRegistration.refCode !== "" ? (
                      <IconTrash
                        width="30px"
                        height="30px"
                        style={{ marginLeft: "5px", color: "#F1416C" }}
                        onClick={handleRemoveRefCode}
                        type="button"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </th>
              </tr>
            </table>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default FiveSummaryWebIndividu;
